import React, { memo } from "react";
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";
import { getDailyTargetQty } from "../../../utility/dispatchScheduleDates";

const DispatchScheduleItems = ({
  itemList,
  itemOptions,
  handleItemChange,
  handleAddItem,
  handleDeleteItem,
  errors,
  startDate,
  endDate,
}) => {
  const getRowOptions = (currentIndex) => {
    const selectedIds = new Set(
      itemList
        .filter((_, i) => i !== currentIndex)
        .map((row) => String(row.item_id))
        .filter(Boolean)
    );

    return itemOptions.filter((opt) => !selectedIds.has(String(opt.id)));
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Grid container spacing={1} sx={{ mb: 1, fontWeight: 600 }}>
        <Grid item xs={12} md={5}>
          Item
        </Grid>
        <Grid item xs={8} md={3}>
          Quantity
        </Grid>
        <Grid item xs={4} md={2}>
          Rate
        </Grid>
        <Grid item xs={12} md={2} />
      </Grid>

      {itemList.map((row, index) => (
        <Grid container spacing={1} key={index} alignItems="center" sx={{ mb: 1 }}>
          <Grid item xs={12} md={5}>
            <Autocomplete
              size="small"
              options={getRowOptions(index)}
              isOptionEqualToValue={(option, value) =>
                String(option?.id) === String(value?.id)
              }
              getOptionLabel={(option) =>
                typeof option === "string"
                  ? option
                  : `${option.itemname || ""}${option.item_code ? ` (${option.item_code})` : ""}`
              }
              value={
                getRowOptions(index).find(
                  (opt) => String(opt.id) === String(row.item_id)
                ) ||
                itemOptions.find(
                  (opt) => String(opt.id) === String(row.item_id)
                ) ||
                null
              }
              onChange={(event, newValue) =>
                handleItemChange(index, "item", newValue)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Item"
                  error={Boolean(errors?.[`item_${index}`])}
                  helperText={errors?.[`item_${index}`] || ""}
                />
              )}
            />
          </Grid>
          <Grid item xs={8} md={3}>
            <TextField
              size="small"
              fullWidth
              type="number"
              label="Quantity"
              value={row.qty}
              InputProps={{ readOnly: true }}
              error={Boolean(errors?.[`qty_${index}`])}
              helperText={
                errors?.[`qty_${index}`] ||
                (row.qty && startDate && endDate
                  ? `~${getDailyTargetQty(row.qty, startDate, endDate)} / day invoice target`
                  : "")
              }
            />
          </Grid>
          <Grid item xs={4} md={2}>
            <TextField
              size="small"
              fullWidth
              type="number"
              label="Rate"
              value={row.rate}
              InputProps={{ readOnly: true }}
              error={Boolean(errors?.[`rate_${index}`])}
              helperText={errors?.[`rate_${index}`] || ""}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Tooltip title="Add row">
              <IconButton color="primary" onClick={handleAddItem}>
                <AddBoxIcon />
              </IconButton>
            </Tooltip>
            {itemList.length > 1 && (
              <Tooltip title="Remove row">
                <IconButton color="error" onClick={() => handleDeleteItem(index)}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export default memo(DispatchScheduleItems);
